import React, { useEffect, useState, useMemo, useRef } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Grid, TableContainer } from "@mui/material";
import { Icon } from '@iconify/react';
import { StonePopUpFields } from 'Components/Pages/Gdev/Trading/Popup';
import { toPlainFields } from 'Components/Pages/Gdev/Trading/fieldconverter';
import Select, { components } from 'react-select';


const ImagePopUp = ({ onClose, itemlist, index }) => {

    const [images, setImages] = useState(itemlist[index]?.imagefile || []); // Initialize with existing images or empty

    const MAX_IMAGES = 5;

    const handleImageChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const newImages = selectedFiles.map((file) => ({
            name: file.name,
            url: URL.createObjectURL(file),
            file, // Keep the file for later upload
        }));

        if (images.length + newImages.length > MAX_IMAGES) {
            alert(`You can only select up to ${MAX_IMAGES} images.`);
            return;
        }

        setImages((prevImages) => [...prevImages, ...newImages]);
    };

    const handleRemoveImage = (imageIndex) => {
        setImages((prevImages) => prevImages.filter((_, i) => i !== imageIndex));
    };

    const handleSave = () => {
        // Save updated images to the item list
        itemlist[index].imagefile = images;
        onClose();
    };

    console.log('checkreadimages ', images);
    


    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header">
                    <p style={{ fontSize: "14px", fontWeight: "bold" }}>
                        Add Stone Details
                    </p>
                    <Icon
                        style={{
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#627282",
                        }}
                        icon="carbon:close-filled"
                        onClick={onClose} // Close the modal
                    />
                </div>
                <div>
                    {images.length < MAX_IMAGES && (
                        <div>
                            <label
                                style={{
                                    display: "inline-block",
                                    padding: "10px 20px",
                                    background: "#007bff",
                                    color: "#fff",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                }}
                            >
                                <FaPlus style={{ marginRight: "5px" }} />
                                Add Images
                                <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleImageChange}
                                    style={{ display: "none" }}
                                />
                            </label>
                        </div>
                    )}
                    <div
            style={{
              maxHeight: "300px", // Adjust the height as needed
              overflowY: "auto", // Enable vertical scrolling
              marginTop: "10px",
            }}>
                    <Grid container spacing={2} columns={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
                        {images.map((img, i) => (

                            <Grid
                                // key={index}
                                item
                                xs={4}
                                sm={3}
                                md={2}
                                lg={2}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "5px",
                                }}
                            >
                                <img
                                    src={img.url || img}
                                    alt={`Imagex`}
                                    style={{ height: '200px', width: '250px' }}
                                    className="image-preview"
                                />
                                <button
                                    className="delete-button"
                                    onClick={() => handleDeleteImage(i)}
                                >
                                    <FaTrash />
                                </button>
                            </Grid>

                        ))}
                    </Grid>
                    </div>
                    <div className="modal-footer" style={{ marginTop: "20px" }}>
          <button
            onClick={handleSave}
            style={{
              padding: "10px 20px",
              background: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            Save
          </button>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: "#dc3545",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
                </div>
            </div></div>
    )
}

export default ImagePopUp